const formatNumber = (value) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  return Number(value).toLocaleString("en-IN");
};

const formatValue = (value, suffix = "") => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  return `${value}${suffix}`;
};

const getMaxCapacity = (hotel, seatingType) => {
  const capacities =
    hotel?.ballrooms?.flatMap(
      (ballroom) => ballroom.capacities || []
    ) || [];

  const values = capacities
    .filter(
      (item) => item.seating_type === seatingType
    )
    .map((item) => Number(item.capacity))
    .filter((value) => !Number.isNaN(value));

  if (!values.length) return "—";

  return `${Math.max(...values).toLocaleString(
    "en-IN"
  )}`;
};

const getLargestBallroom = (hotel) => {
  const ballrooms = hotel?.ballrooms || [];

  if (!ballrooms.length) return null;

  return ballrooms.reduce((largest, ballroom) => {
    const currentArea =
      Number(ballroom.carpet_area) || 0;

    const largestArea =
      Number(largest?.carpet_area) || 0;

    return currentArea > largestArea
      ? ballroom
      : largest;
  }, ballrooms[0]);
};

const getTotalVenueArea = (hotel) => {
  const spaces = hotel?.venue_spaces || [];

  const total = spaces.reduce(
    (sum, space) =>
      sum + (Number(space.area) || 0),
    0
  );

  return total
    ? `${total.toLocaleString("en-IN")} sq.ft.`
    : "—";
};

const getMeetingRooms = (hotel) => {
  return (
    hotel?.venue_spaces?.filter(
      (space) =>
        space.space_type === "meeting_room"
    ).length || 0
  );
};

const getVenueTypes = (hotel) => {
  const types = [
    ...new Set(
      (hotel?.venue_spaces || [])
        .map((space) => space.space_type)
        .filter(Boolean)
    ),
  ];

  if (!types.length) return "—";

  return types
    .map((type) =>
      type
        .replaceAll("_", " ")
        .replace(/\b\w/g, (c) =>
          c.toUpperCase()
        )
    )
    .join(", ");
};

const getLargestVenueSpace = (hotel) => {
  const spaces = hotel?.venue_spaces || [];

  if (!spaces.length) return null;

  return spaces.reduce((largest, space) => {
    const currentArea =
      Number(space.area) || 0;

    const largestArea =
      Number(largest?.area) || 0;

    return currentArea > largestArea
      ? space
      : largest;
  }, spaces[0]);
};

// const getBallroomImages = (hotel) => {
//   return (
//     hotel?.ballrooms?.flatMap(
//       (ballroom) =>
//         ballroom?.images
//           ?.sort(
//             (a, b) =>
//               (a.display_order || 0) -
//               (b.display_order || 0)
//           )
//           .map((item) => item.image)
//           .filter(Boolean) || []
//     ) || []
//   );
// };
export const getOtherBallrooms = (hotel) => {
  const ballrooms = hotel?.ballrooms || [];

  if (!ballrooms.length) return [];

  const largestBallroom = getLargestBallroom(hotel);

  return ballrooms.filter(
    (ballroom) => ballroom.id !== largestBallroom?.id
  );
};

// const hasValue = (value) => {
//   if (value === null || value === undefined || value === "") {
//     return false;
//   }

//   if (Array.isArray(value)) {
//     return value.length > 0;
//   }

//   return true;
// };

export const COMPARISON_SECTIONS = [
  {
    title: "Hotel Overview",

    fields: [
      {
        key: "star_rating",
        label: "Star Rating",
        getValue: (hotel) =>
          hotel.star_rating
            ? `${hotel.star_rating} Star`
            : "—",
      },

      {
        key: "city",
        label: "City",
        getValue: (hotel) =>
          hotel.city || "—",
      },

      {
        key: "state",
        label: "State",
        getValue: (hotel) =>
          hotel.state || "—",
      },

   
    ],
  },

  {
    title: "Accommodation",

    fields: [
      {
        key: "total_rooms",
        label: "Total Rooms",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.total_rooms
          ),
      },

      {
        key: "total_suites",
        label: "Total Suites",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.total_suites
          ),
      },

      {
        key: "deluxe_rooms",
        label: "Deluxe Rooms",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.deluxe_rooms
          ),
      },

      {
        key: "executive_rooms",
        label: "Executive Rooms",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.executive_rooms
          ),
      },

      {
        key: "premium_rooms",
        label: "Premium Rooms",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.premium_rooms
          ),
      },

      {
        key: "club_rooms",
        label: "Club Rooms",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.club_rooms
          ),
      },

      {
        key: "luxury_rooms",
        label: "Luxury Rooms",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.luxury_rooms
          ),
      },

      {
        key: "studio_rooms",
        label: "Studio Rooms",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.studio_rooms
          ),
      },

      {
        key: "junior_suites",
        label: "Junior Suites",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.junior_suites
          ),
      },

      {
        key: "executive_suites",
        label: "Executive Suites",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.executive_suites
          ),
      },

      {
        key: "presidential_suites",
        label: "Presidential Suites",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.presidential_suites
          ),
      },

      {
        key: "villas",
        label: "Villas",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.villas
          ),
      },

      {
        key: "cottages",
        label: "Cottages",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.cottages
          ),
      },

      {
        key: "bungalows",
        label: "Bungalows",
        getValue: (hotel) =>
          formatNumber(
            hotel.inventory?.bungalows
          ),
      },
    ],
  },

  {
    title: "Event & MICE",

    fields: [
      {
        key: "total_ballrooms",
        label: "Total Ballrooms",
        getValue: (hotel) =>
          hotel.ballrooms?.length || 0,
      },

      {
        key: "meeting_rooms",
        label: "Meeting Rooms",
        getValue: (hotel) =>
          getMeetingRooms(hotel),
      },

      {
        key: "other_venue_spaces",
        label: "Other Venue Spaces",
        getValue: (hotel) =>
          hotel.venue_spaces?.length || 0,
      },
      {
        key: "theatre_capacity",
        label: "Theatre Capacity",
        getValue: (hotel) =>
          getMaxCapacity(
            hotel,
            "theatre"
          ),
      },

      {
        key: "classroom_capacity",
        label: "Classroom Capacity",
        getValue: (hotel) =>
          getMaxCapacity(
            hotel,
            "classroom"
          ),
      },

      {
        key: "banquet_capacity",
        label: "Banquet Capacity",
        getValue: (hotel) =>
          getMaxCapacity(
            hotel,
            "banquet"
          ),
      },

      {
        key: "cocktail_capacity",
        label: "Cocktail Capacity",
        getValue: (hotel) =>
          getMaxCapacity(
            hotel,
            "cocktail"
          ),
      },

      {
        key: "u_shape_capacity",
        label: "U-Shape Capacity",
        getValue: (hotel) =>
          getMaxCapacity(
            hotel,
            "u_shape"
          ),
      },

      {
        key: "boardroom_capacity",
        label: "Boardroom Capacity",
        getValue: (hotel) =>
          getMaxCapacity(
            hotel,
            "boardroom"
          ),
      },

      {
        key: "cluster_capacity",
        label: "Cluster Capacity",
        getValue: (hotel) =>
          getMaxCapacity(
            hotel,
            "cluster"
          ),
      },
    ],
  },

  {
    title: "Largest Ballroom Details",

    fields: [
      {
        key: "ballroom_name",
        label: "Ballroom Name",
        getValue: (hotel) =>
          getLargestBallroom(hotel)?.name ||
          "—",
      },

      {
        key: "carpet_area",
        label: "Carpet Area",
        getValue: (hotel) => {
          const ballroom =
            getLargestBallroom(hotel);

          return ballroom?.carpet_area
            ? `${formatNumber(
                ballroom.carpet_area
              )} sq.ft.`
            : "—";
        },
      },

      {
        key: "pre_function_area",
        label: "Pre-Function Area",
        getValue: (hotel) => {
          const area =
            getLargestBallroom(hotel)
              ?.pre_function_area?.area;

          return area
            ? `${formatNumber(area)} sq.ft.`
            : "—";
        },
      },

      {
        key: "pre_function_capacity",
        label: "Pre-Function Capacity",
        getValue: (hotel) => {
          const capacity =
            getLargestBallroom(hotel)
              ?.pre_function_area?.capacity;

          return formatValue(
            capacity,
          );
        },
      },
    ],
  },

  {
    title: "Other Venue Spaces",

    fields: [
      {
        key: "total_venue_area",
        label: "Total Venue Area",
        getValue: (hotel) =>
          getTotalVenueArea(hotel),
      },

      {
        key: "largest_venue_space",
        label: "Largest Venue Space",
        getValue: (hotel) =>
          getLargestVenueSpace(hotel)?.name ||
          "—",
      },

      {
        key: "largest_venue_area",
        label: "Largest Venue Space Area",
        getValue: (hotel) => {
          const space =
            getLargestVenueSpace(hotel);

          return space?.area
            ? `${formatNumber(
                space.area
              )} sq.ft.`
            : "—";
        },
      },

      {
        key: "largest_venue_capacity",
        label: "Largest Venue Capacity",
        getValue: (hotel) => {
          const space =
            getLargestVenueSpace(hotel);

          return space?.max_capacity
            ? `${formatNumber(
                space.max_capacity
              )}`
            : "—";
        },
      },

      {
        key: "venue_types",
        label: "Venue Types",
        getValue: (hotel) =>
          getVenueTypes(hotel),
      },
    ],
  },
];

export const getBallroomList = (hotel) => {
  return hotel?.ballrooms || [];
};

export const getVenueSpaceList = (hotel) => {
  return hotel?.venue_spaces || [];
};

